
<template>
  <div></div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "OidcCallback",
  methods: {
    ...mapActions(["oidcSignInCallback"]),
  },
  mounted() {
    console.log("*************CALLBACK SUCCEEDED1****************");
    this.oidcSignInCallback()
      .then((redirectPath) => {
        console.log("*************CALLBACK SUCCEEDED****************");
        console.log(redirectPath);
        this.$router.push({ name: "LandingPage" });
      })
      .catch((err) => {
        console.error(err);
        this.$router.push("/oidc-callback-error"); // Handle errors any way you want
      });
  },
};
</script>